// Redirect for emails and bookmarks created while the My Binders page lived at /tax-binders.
// /tax-binders → /binders. The tax-binder *detail* pages (/tax-binders/$binderId/...) are untouched.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/tax-binders/')({
  beforeLoad: () => {
    throw redirect({
      to: '/binders',
      replace: true,
    });
  },
  component: () => null,
});
